import { styled } from '@mui/material/styles';
import Box, { BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TableRow from '@mui/material/TableRow';
import { RowProps, HalfScreenProps } from '.';
import Colors from '../../theme/colors';

const PageContainer = styled(Box)({
  display: 'flex',
  width: '100%',
  height: '100%',
  flexDirection: 'column',
  overflow: 'hidden',
  overflowY: 'scroll',
});

const HeaderTableRow = styled(TableRow)({
  backgroundColor: Colors.Main.Background,
});

const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  padding: '32px',
});

const TitleContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: '48px',
});

const LabelsContainer = styled(Box)({
  paddingLeft: '8px',
  paddingRight: '8px',
  display: 'flex',
  flexDirection: 'row',
  paddingBottom: '16px',
});

const Row = styled(Box)<BoxProps & RowProps>((props) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  justifyContent: 'space-between',
  marginBottom: props?.addBottomMargin ? '36px' : '0px',
}));

const LabelsInputContainer = styled(Box)({
  display: 'flex',
  flex: 1,
  paddingRight: '16px',
});

const ExpiryDatePickerContainer = styled(Box)({
  display: 'flex',
  backgroundColor: 'blue',
  width: '100%',
  flex: 1,
});

const HalfScreen = styled(Box)<BoxProps & HalfScreenProps>((props) => ({
  width: '45%',
  marginRight: props?.isLeftHalf ? '10%' : '0',
  display: 'flex',
  flexDirection: 'column',
}));

const Title = styled(Typography)({ marginRight: '24px' });

const SectionTitle = styled(Typography)({ marginBottom: '8px' });

const ActionButton = styled(Button)({
  marginTop: '16px',
});

export {
  PageContainer,
  ContentContainer,
  TitleContainer,
  Title,
  ActionButton,
  HeaderTableRow,
  LabelsContainer,
  LabelsInputContainer,
  ExpiryDatePickerContainer,
  HalfScreen,
  Row,
  SectionTitle,
};
